import { styled as e, Box as i } from "@mui/material";
import f from "../header/Header.js";
import x from "../nav/Nav.js";
import { jsxs as d, jsx as o } from "react/jsx-runtime";
const h = e(i)`
  color: aliceblue;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
`, s = e(i)`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  max-width: 100%;
`, j = ({
  children: l,
  navItems: t,
  logo: r,
  highlight: n,
  borderline: c,
  menuIcon: m,
  heads: a
}) => /* @__PURE__ */ d(h, {
  children: [a, /* @__PURE__ */ o(f, {
    logo: r || "",
    children: /* @__PURE__ */ o(x, {
      navItems: t,
      highlight: n || "",
      menuIcon: m || "",
      borderline: c
    })
  }), /* @__PURE__ */ o(s, {
    children: l
  })]
});
export {
  j as default
};
//# sourceMappingURL=Layout.js.map
